import { css as e, variants as t, modifier as s, styled as n } from "@lokalise/styled";
import { typography as l, value as i, spacing as r } from "../../utils/theme/index.js";
import { oneLineEllipsis as a } from "../../utils/styles/oneLineEllipsis.js";
const d = e`
	${a};
	box-sizing: border-box;
	${l("body.tiny.strong")};
	border-radius: ${i("radius.tag")};
	border-width: 1px;
	border-style: solid;
	border-color: ${(o) => o.$color};
	max-width: max-content;
	width: min-content;
	line-height: 14px; // This is needed so the text appears centered
	height: 20px;
	padding: 2px ${r(2)};

	${t("$variant", {
  solid: e`
			color: ${i("color.text.inverse")};
			background-color: ${(o) => o.$color};
		`,
  outlined: e`
			color: ${(o) => o.$color};
			background-color: transparent;
		`
})};

	${t("$size", {
  default: e`
			line-height: 14px; // This is needed so the text appears centered
			height: 20px;
			padding: 2px ${r(2)};
		`,
  small: e`
			font-size: 10px;
			line-height: 1;
			padding: 1px 5px 2px;
			height: auto;
		`
})};

	${s(
  "$fullWidth",
  e`
			width: 100%;
			display: inline-block;
		`
)}
`, $ = n.div`
	${d};
`, g = n.button`
	${d};

	cursor: pointer;

	&:hover {
		filter: brightness(1.1);
	}
`;
export {
  $ as SimpleTag,
  g as TagButton
};
//# sourceMappingURL=styles.js.map
